import React from 'react';
import Icon from '@applied/dragonfruit/src/components/Icon/Icon';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import { useAppliedLogoSrc } from 'utils/reskin_utils';

import './navbar.scss';

type NavbarLinkProps = {
  label: string;
  href: string;
};

function NavbarLink(props: NavbarLinkProps): JSX.Element {
  const { label, href } = props;
  return (
    <a href={href} className="navbar-link">
      <Typography variant="body">{label}</Typography>
    </a>
  );
}

export function Navbar(): JSX.Element {
  const logoSrc = useAppliedLogoSrc();
  return (
    <Flex className="navbar" direction="row" gap="md" alignment="center" justify="space-between">
      <Flex className="navbar-logo" direction="row" gap="xs" alignment="center">
        <Icon src={logoSrc} height={29} />
        <Typography variant="header">Applied Intuition</Typography>
      </Flex>
      <Flex className="navbar-links" direction="row" gap="md" alignment="center">
        <NavbarLink label="Role" href="#role" />
        <NavbarLink label="Compensation" href="#compensation" />
        <NavbarLink label="Equity" href="#equity" />
        <NavbarLink label="Benefits" href="#benefits" />
        <NavbarLink label="Culture" href="#culture" />
        <NavbarLink label="Resources" href="#resources" />
        <NavbarLink label="Ready to Sign?" href="#ready-to-sign" />
      </Flex>
    </Flex>
  );
}
